import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from '@mui/material';
import SimpleDialog from 'core/components/Dialogs/SimpleDialog';
import { useEffect } from 'react';
import {
  CheckboxElement,
  FormContainer,
  TextFieldElement,
  useForm,
} from 'react-hook-form-mui';
import { boolean, number, object } from 'yup';
import type { ProductComponent } from 'models/product/productDetail';
import type { FC } from 'react';
import type { SubmitHandler } from 'react-hook-form-mui';

const ComponentDialog: FC<ComponentDialogProps> = ({
  productComponent,
  open,
  onCancel,
  onSubmit,
}) => {
  const schema = object<ComponentForm>({
    price: number().max(100_000_000).positive().required(),
    notPrintInDocuments: boolean(),
  }).required();

  const formContext = useForm<ComponentForm>({
    mode: 'onTouched',
    defaultValues: { count: productComponent?.count },
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (open) {
      formContext.setValue('count', productComponent?.count ?? 0);
      formContext.setValue(
        'notPrintInDocuments',
        productComponent?.notPrintInDocuments ?? false
      );
    }
  }, [open, formContext, productComponent]);

  const handleSave: VoidFunction = () => {
    onSubmit(formContext.getValues());
  };

  return (
    <SimpleDialog
      title={productComponent?.name ?? 'Комплектующее'}
      content={
        <FormContainer formContext={formContext} onSuccess={onSubmit}>
          <TextFieldElement
            fullWidth
            label='Количество'
            name='count'
            type='number'
            margin='normal'
            required
          />
          <CheckboxElement
            label='Не отображать в документах'
            name='notPrintInDocuments'
          />
        </FormContainer>
      }
      open={open}
      onClose={onCancel}
      maxWidth={'sm'}
      fullWidth
      actions={
        <>
          <Button onClick={handleSave}>Сохранить</Button>
          <Button onClick={onCancel}>Отмена</Button>
        </>
      }
    />
  );
};

export interface ComponentForm {
  count: number;
  notPrintInDocuments: boolean;
}

export interface ComponentDialogProps {
  productComponent?: ProductComponent;
  open: boolean;
  onSubmit: SubmitHandler<ComponentForm>;
  onCancel: VoidFunction;
}

export default ComponentDialog;
